import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { canEdit, getUserType } from "../permissions";
import API_BASE from "../config";

const EditCustomer = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const customer = location.state?.customer;
    const userType = getUserType();
    const allowEdit = canEdit(userType, "customers");

    const [form, setForm] = useState({
        id: "", name: "", phone: "", customer_id: "", address: "",
        father: "", dob: "", sphone: "", gmail: "", proffession: "", city: "",
    });
    const [saving, setSaving] = useState(false);
    const [success, setSuccess] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        if (!allowEdit) { navigate("/dashboard/customers"); return; }
        if (!customer) { navigate("/dashboard/customers"); return; }
        setForm({
            id: customer.id || "", name: customer.name || "",
            phone: customer.phone || "", customer_id: customer.customer_id || "",
            address: customer.address || "", father: customer.father || "",
            dob: customer.dob || "", sphone: customer.sphone || "",
            gmail: customer.gmail || "", proffession: customer.proffession || "",
            city: customer.city || "",
        });
    }, [customer, navigate, allowEdit]);

    if (!allowEdit) return null;

    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = (e) => {
        e.preventDefault();
        setSaving(true); setError(""); setSuccess("");

        const formData = new URLSearchParams();
        Object.keys(form).forEach((key) => {
            if (key !== "id") formData.append(key, form[key]);
        });

        fetch(`${API_BASE}/api/updatedatas`, {
            method: "POST",
            headers: { Authorization: "1", Table: "customers", Id: form.id },
            body: formData,
        })
            .then((r) => r.json())
            .then((json) => {
                setSaving(false);
                if (json.status == true) { setSuccess("Customer updated!"); setTimeout(() => navigate("/dashboard/customers"), 1500); }
                else setError(json.message || "Failed to update.");
            })
            .catch(() => { setSaving(false); setError("Error updating customer."); });
    };

    return (
        <>
            <style>{`
        .ec-page{max-width:900px;margin:0 auto}
        .ec-hdr{display:flex;align-items:center;gap:14px;margin-bottom:24px}
        .ec-back{padding:8px 16px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:10px;color:#334155;cursor:pointer;font-size:14px;font-weight:500;font-family:'Inter',sans-serif;transition:all .2s;display:flex;align-items:center;gap:6px}
        .ec-back:hover{background:#f1f5f9;border-color:#cbd5e1}
        .ec-title{font-size:22px;font-weight:700;color:#0f172a}
        .ec-sub{font-size:13px;color:#64748b}
        .ec-card{background:#fff;border:1px solid #e2e8f0;border-radius:16px;padding:28px;box-shadow:0 1px 3px rgba(0,0,0,.04)}
        .ec-sec{font-size:14px;font-weight:600;color:#0f172a;margin-bottom:16px;padding-bottom:10px;border-bottom:1px solid #f1f5f9;display:flex;align-items:center;gap:8px}
        .ec-grid{display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:28px}
        .ec-field{display:flex;flex-direction:column;gap:6px}
        .ec-field.full{grid-column:1/-1}
        .ec-field label{font-size:12px;font-weight:600;color:#64748b;text-transform:uppercase;letter-spacing:.4px}
        .ec-field input,.ec-field select,.ec-field textarea{padding:11px 14px;border-radius:10px;border:1px solid #e2e8f0;font-size:14px;font-family:'Inter',sans-serif;color:#1e293b;background:#f8fafc;outline:none;transition:all .2s}
        .ec-field input:focus,.ec-field select:focus,.ec-field textarea:focus{border-color:#93c5fd;box-shadow:0 0 0 3px rgba(59,130,246,.08);background:#fff}
        .ec-field textarea{min-height:80px;resize:vertical}
        .ec-actions{display:flex;gap:12px;margin-top:8px;padding-top:20px;border-top:1px solid #f1f5f9}
        .ec-save{padding:12px 28px;background:linear-gradient(135deg,#2563eb,#3b82f6);color:#fff;border:none;border-radius:10px;font-size:14px;font-weight:600;cursor:pointer;font-family:'Inter',sans-serif;transition:all .2s;display:flex;align-items:center;gap:8px}
        .ec-save:hover:not(:disabled){background:linear-gradient(135deg,#1d4ed8,#2563eb);box-shadow:0 4px 14px rgba(37,99,235,.3);transform:translateY(-1px)}
        .ec-save:disabled{opacity:.6;cursor:not-allowed;transform:none}
        .ec-cancel{padding:12px 24px;background:#f8fafc;color:#64748b;border:1px solid #e2e8f0;border-radius:10px;font-size:14px;font-weight:500;cursor:pointer;font-family:'Inter',sans-serif;transition:all .2s}
        .ec-cancel:hover{background:#f1f5f9;color:#334155}
        .ec-spinner{width:16px;height:16px;border:2px solid rgba(255,255,255,.3);border-top-color:#fff;border-radius:50%;animation:ec-sp .6s linear infinite}
        @keyframes ec-sp{to{transform:rotate(360deg)}}
        .ec-alert{padding:12px 16px;border-radius:10px;font-size:13px;margin-bottom:20px;font-weight:500}
        .ec-alert-ok{background:#ecfdf5;color:#059669;border:1px solid #a7f3d0}
        .ec-alert-err{background:#fef2f2;color:#dc2626;border:1px solid #fecaca}
        @media(max-width:768px){.ec-grid{grid-template-columns:1fr}.ec-card{padding:20px}.ec-actions{flex-direction:column}}
      `}</style>

            <div className="ec-page">
                <div className="ec-hdr">
                    <button className="ec-back" onClick={() => navigate("/dashboard/customers")}>← Back</button>
                    <div>
                        <div className="ec-title">Edit Customer</div>
                        <div className="ec-sub">ID: {form.id}</div>
                    </div>
                </div>

                {success && <div className="ec-alert ec-alert-ok">✅ {success}</div>}
                {error && <div className="ec-alert ec-alert-err">⚠️ {error}</div>}

                <form className="ec-card" onSubmit={handleSubmit}>
                    <div className="ec-sec">👤 Personal Details</div>
                    <div className="ec-grid">
                        <div className="ec-field"><label>Full Name</label><input name="name" value={form.name} onChange={handleChange} required /></div>
                        <div className="ec-field"><label>Father's Name</label><input name="father" value={form.father} onChange={handleChange} /></div>
                        <div className="ec-field"><label>Phone</label><input name="phone" value={form.phone} onChange={handleChange} /></div>
                        <div className="ec-field"><label>Secondary Phone</label><input name="sphone" value={form.sphone} onChange={handleChange} /></div>
                        <div className="ec-field"><label>Email</label><input name="gmail" type="email" value={form.gmail} onChange={handleChange} /></div>
                        <div className="ec-field"><label>Date of Birth</label><input name="dob" value={form.dob} onChange={handleChange} placeholder="DD-MM-YYYY" /></div>
                    </div>

                    <div className="ec-sec">📍 Address & Other</div>
                    <div className="ec-grid">
                        <div className="ec-field"><label>City</label><input name="city" value={form.city} onChange={handleChange} /></div>
                        <div className="ec-field"><label>Profession</label><input name="proffession" value={form.proffession} onChange={handleChange} /></div>
                        <div className="ec-field full"><label>Full Address</label><input name="address" value={form.address} onChange={handleChange} /></div>
                    </div>

                    <div className="ec-actions">
                        <button type="submit" className="ec-save" disabled={saving}>
                            {saving && <span className="ec-spinner" />}
                            {saving ? "Saving..." : "💾 Save Changes"}
                        </button>
                        <button type="button" className="ec-cancel" onClick={() => navigate("/dashboard/customers")}>Cancel</button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default EditCustomer;
